import { render, staticRenderFns } from "./TraderBets.vue?vue&type=template&id=b5f214b0&scoped=true&"
import script from "./TraderBets.vue?vue&type=script&lang=js&"
export * from "./TraderBets.vue?vue&type=script&lang=js&"
import style0 from "./TraderBets.vue?vue&type=style&index=0&id=b5f214b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f214b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
